import React, { useState } from "react"
import styled, { withTheme } from "styled-components"
import Link from "next/link"
import Image from "next/image"
import useInject from "~/hooks/useInject"

import Header, {
  minHeightDesktop,
  minHeightMobile,
} from "~/components/dashboard/Layout/Header/OldAppHeader"

import WinItButton from "~/components/WinItButton"
import ComputerApp from "~/public/static/images/png/ComputerApp.png"
import IconParkingSubmit from "~/public/static/images/svg/IconParkingSubmit.svg"
import IconParkingReview from "~/public/static/images/svg/IconParkingReview.svg"
import IconHammer from "~/public/static/images/svg/IconHammer.svg"
import IconSaveMoney from "~/public/static/images/svg/IconSaveMoney.svg"
import IconTrafficSubmit from "~/public/static/images/svg/IconTrafficSubmit.svg"
import IconTrafficQuote from "~/public/static/images/svg/IconTrafficQuote.svg"
import HeroPhone from "~/public/static/images/png/HeroPhone.png"
import HeroNYC from "~/public/static/images/webp/hero-nyc.webp"
import GooglePlayButton from "~/public/static/images/svg/GooglePlayButton.svg"
import AppStoreButton from "~/public/static/images/svg/AppStoreButton.svg"
import Spacer from "~/components/Spacer"
import DesktopContainer from "~/components/DesktopContainer"
import FeaturedInLogo from "~/components/dashboard/Layout/Footer/logos/FeaturedInLogo"
import Footer from "~/components/Footer"
import Redirect from "~/components/Redirect"

const FullscreenContainer = styled.div`
  width: 100%;
  height: calc(
    100vh - ${(props) => (props.headerSpace ? minHeightDesktop : "0px")}
  );
  ${(props) => props.theme.media.mobile`
    height: calc(100vh - ${props.headerSpace ? minHeightMobile : "0px"});
  `};
`

const HeroImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const SavingsImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const HeroTitleContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${(props) => (props.headerSpace ? minHeightDesktop : "0px")};
  ${(props) => props.theme.media.mobile`
    margin-bottom: ${props.headerSpace ? minHeightMobile : "0px"}
  `}
`

const HeroTitle = styled.h1`
  font-family: ${(props) => props.theme.fonts.avenirNextDemi};
  font-size: 3em;
  text-align: center;
  ${(props) => props.theme.media.smallDesktop`
    font-size: 2.4em;
  `};
  ${(props) => props.theme.media.mobile`
    font-size: 2em;
  `};
  color: white;
  line-height: 1.5em;
`

const HeroSubtitle = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1.125em;
  text-align: center;
  max-width: 390px;
  color: ${(props) => props.color || "white"};
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${(props) => props.theme.media.mobile`
    flex-direction: column;
  `};
`

const SmallTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextDemi};
  font-size: 2.25em;
  text-align: center;
`

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  span {
    font-size: 2em;
    font-family: ${(props) => props.theme.fonts.avenirNextThin};
    color: ${(props) => props.theme.colors.primary};
  }
`

const ToggleButton = styled.button.attrs({ type: "button" })`
  font-size: 2em;
  font-family: ${(props) => props.theme.fonts.avenirNextThin};
  color: ${(props) => props.theme.colors.primary};
  margin-left: 0.125em;
  margin-right: 0.125em;
  background-color: Transparent;
  border: none;
  opacity: ${(props) => (props.$selected ? 1 : 0.5)};
  cursor: pointer;
`

const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.media.smallDesktop`
    flex-direction: column;
  `};
`

const CardContainer = styled.div`
  display: flex;
  width: 225px;
  height: 300px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

const CardImage = styled.img`
  width: ${(props) => (props.small ? "65%" : "auto")};
  max-width: 90%;
  max-height: 90%;
`

const CardImageContainer = styled.div`
  display: flex;
  width: 195px;
  height: 160px;
  justify-content: center;
  align-items: center;
`

const CardText = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1em;
  text-align: ${(props) => (props.alignRight ? "right" : "center")};
  color: ${(props) => props.theme.colors.text.subContent};
`

const SavedUsersContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 1em;
`

const SavedUserTitle = styled.div`
  max-width: 400px;
`

const MultiWeightTitle = styled.div`
  font-family: ${(props) =>
    props.bold
      ? props.theme.fonts.avenirNextDemi
      : props.theme.fonts.avenirNextRegular};
  font-size: 2.25em;
  text-align: left;
  color: ${(props) => props.theme.colors.text.header};
  ${(props) => props.theme.media.mobile`
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.65);
    color: white;
  `};
`

const FeaturedInContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 4em;
  padding-bottom: 4em;
`

const UseItContainer = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.background.main};
`

const UseItRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4em;
  padding-bottom: 4em;
  ${(props) => props.theme.media.smallDesktop`
    flex-direction: column;
  `};
`

const DownloadAppContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  ${(props) => props.theme.media.smallDesktop`
    align-items: center;
  `};
`

const UseItText = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1em;
  text-align: right;
  max-width: 200px;
  color: ${(props) => props.theme.colors.text.subContent};
  ${(props) => props.theme.media.smallDesktop`
    text-align: center;
  `};
`

const StoresContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 240px;
  ${(props) => props.theme.media.tiny`
    width: 250px;
  `};
`

const DownloadButton = styled.img`
  width: 110px;
  ${(props) => props.theme.media.tiny`
    width: 120px;
    height: 100%;
    object-fit: contain;
  `};
`

const howItWorks = {
  parking: [
    {
      title: "SUBMIT",
      text:
        "Snap a picture of your ticket, or use the app to search NYC’s servers for tickets associated with your license plate.",
      image: IconParkingSubmit,
    },
    {
      title: "REVIEW",
      text:
        "Submit any evidence right in the app. Our team will inspect your ticket for errors.",
      image: IconParkingReview,
    },
    {
      title: "DISPUTE",
      text:
        "You're all done! Our team will handle every aspect of your dispute, and update you every step of the way.",
      image: IconHammer,
    },
    {
      title: "SAVE",
      text:
        "Every ticket is covered by our risk-free guarantee: We don’t charge you unless your ticket is totally dismissed! Our fee is just 50% of the fine.",
      image: IconSaveMoney,
      smallerImage: true,
    },
  ],
  traffic: [
    {
      title: "Submit",
      text: "Upload the details of your ticket.",
      image: IconTrafficSubmit,
    },
    {
      title: "Attorney",
      text: "Hire an attorney to work on your case and represent you.",
      image: IconHammer,
    },
    {
      title: "Easy Process",
      text:
        "Pay one up-front fee for your dispute, and stay up to date every step of the way.",
      image: IconTrafficQuote,
    },
  ],
}

const mapStore = (store) => ({
  currentHost: store.ui.currentHost,
  isMobile: store.ui.isMobile,
  isStateAffiliatedWithWinitLaw:
    store.trafficLookup.isStateAffiliatedWithWinitLaw,
})

const Landing = ({ theme }) => {
  const [flow, setFlow] = useState("parking")
  const { currentHost, isMobile, isStateAffiliatedWithWinitLaw } = useInject(
    mapStore
  )
  if (currentHost.includes("paynyctickets.com"))
    return <Redirect to="/parking/pay" />
  if (currentHost.includes("divorcelookup.com"))
    return <Redirect to="/divorce/lookup" />
  return (
    <>
      <Header />
      <FullscreenContainer headerSpace>
        <HeroImageContainer>
          <Image
            alt="WinIt App Manhattan"
            src={HeroNYC}
            layout="fill"
            objectFit="cover"
            priority
          />
          <DesktopContainer>
            <HeroTitleContainer headerSpace>
              <HeroTitle>
                Combining Tech & Law
                <br />
                to Keep You Protected
              </HeroTitle>
              <Spacer desktop={10} mobile={10} />
              <HeroSubtitle>Let&apos;s Fight Your Tickets</HeroSubtitle>
              <Spacer desktop={64} mobile={64} />
              <ButtonContainer>
                <Link href="/parking/submit" passHref>
                  {/* NEED TO PASS HREF FOR SEO!!!! */}
                  <WinItButton
                    as="a"
                    color="blue"
                    width="250px"
                    height={70}
                    fontSize="1em"
                    shape="square"
                  >
                    Parking Ticket
                  </WinItButton>
                </Link>
                <Spacer direction="width" desktop={64} mobile={64} />
                <Spacer desktop={16} mobile={16} />
                {/* NEED TO PASS HREF FOR SEO!!!! */}
                <Link href="/traffic-tickets" passHref>
                  <WinItButton
                    as="a"
                    color="red"
                    width="250px"
                    height={70}
                    fontSize="1em"
                    shape="square"
                  >
                    Traffic Ticket
                  </WinItButton>
                </Link>
              </ButtonContainer>
            </HeroTitleContainer>
          </DesktopContainer>
        </HeroImageContainer>
      </FullscreenContainer>
      <DesktopContainer>
        <Spacer desktop={96} mobile={96} />
        <HeroTitleContainer>
          <Spacer desktop={16} mobile={16} />
          <SmallTitle>How It Works</SmallTitle>
          <Spacer desktop={16} mobile={16} />
          <HeroSubtitle $color={theme.colors.text.subContent}>
            Parking ticket and traffic ticket disputes are separate processes
          </HeroSubtitle>
          <Spacer desktop={32} mobile={32} />
          <ToggleContainer>
            <ToggleButton
              onClick={() => setFlow("parking")}
              $selected={flow === "parking"}
            >
              Parking
            </ToggleButton>
            <span>{" | "}</span>
            <ToggleButton
              onClick={() => setFlow("traffic")}
              $selected={flow === "traffic"}
            >
              Traffic
            </ToggleButton>
          </ToggleContainer>
        </HeroTitleContainer>
        <Spacer desktop={32} mobile={32} />
        <CardRow>
          {howItWorks[flow].map((cardContent) => (
            <CardContainer key={cardContent.title}>
              <CardImageContainer>
                <CardImage
                  small={cardContent.smallerImage}
                  src={cardContent.image}
                  alt={cardContent.title}
                />
              </CardImageContainer>
              <HeroSubtitle $color={theme.colors.primary}>
                {cardContent.title}
              </HeroSubtitle>
              <CardText>{cardContent.text}</CardText>
            </CardContainer>
          ))}
        </CardRow>
        <Spacer desktop={48} mobile={48} />
        <ButtonContainer>
          <Link href="/how-it-works" passHref>
            <WinItButton
              as="a"
              color="blue"
              width="200px"
              height={70}
              fontSize="1em"
            >
              Learn More
            </WinItButton>
          </Link>
        </ButtonContainer>
        <Spacer desktop={96} mobile={96} />
      </DesktopContainer>
      <FullscreenContainer>
        <SavingsImageContainer>
          <Image
            alt="Save Money with WinIt"
            src={HeroPhone}
            objectFit="cover"
            layout="fill"
          />
          <DesktopContainer>
            <SavedUsersContainer>
              <HeroSubtitle $color={theme.colors.primary}>
                HOW MUCH YOU WILL SAVE?
              </HeroSubtitle>
              <Spacer desktop={16} mobile={16} />
              <SavedUserTitle>
                <MultiWeightTitle>Our users saved</MultiWeightTitle>
                <MultiWeightTitle bold>Millions of Dollars!</MultiWeightTitle>
              </SavedUserTitle>
              <Spacer desktop={16} mobile={16} />
            </SavedUsersContainer>
          </DesktopContainer>
        </SavingsImageContainer>
      </FullscreenContainer>
      <DesktopContainer>
        <FeaturedInContainer>
          <SmallTitle>Featured In</SmallTitle>
          <Spacer desktop={16} mobile={16} />
          <FeaturedInLogo />
        </FeaturedInContainer>
      </DesktopContainer>
      <UseItContainer>
        <DesktopContainer>
          <UseItRow>
            <Image
              src={ComputerApp}
              alt="Computer-App"
              width={isMobile ? 280 : 500}
              height={isMobile ? 178 : 318}
            />
            <DownloadAppContainer>
              <HeroSubtitle $color={theme.colors.primary}>
                DOWNLOAD OUR FREE APP
              </HeroSubtitle>
              <SmallTitle>Use it everywhere</SmallTitle>
              <Spacer desktop={8} mobile={8} />
              <UseItText>
                Access our services via online browser or the mobile app.
              </UseItText>
              <Spacer desktop={8} mobile={8} />
              <StoresContainer>
                <a href="https://itunes.apple.com/us/app/winit-fight-your-tickets/id929918279">
                  <DownloadButton src={AppStoreButton} alt="App Store" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.winitllc.ticketfighter">
                  <DownloadButton src={GooglePlayButton} alt="Google Play" />
                </a>
              </StoresContainer>
            </DownloadAppContainer>
          </UseItRow>
        </DesktopContainer>
      </UseItContainer>
      <Footer noMedia noDisclaimer />
    </>
  )
}

export default withTheme(Landing)
